/** @jsx h */

import { render, h } from 'preact';
import '@updater-components/loading-spinner';
import './carousel';
import classes from './new-product-intro.module.css';
import { NewProductIntroCard as Card } from './new-product-intro-card';

export const mount = (element, props) => {
  const {
    title,
    subtitle,
    cards,
    slideWidth,
    trackWidth,
    scrollable,
    handleContainerLeave,
    handleCarouselChange,
    handleEnterCard,
    handleLeaveCard,
    handleCardClick,
    handleDashboardClick,
    dashboardLink,
  } = props;

  render(
    !cards.length ? (
      <upd-loading-spinner style="font-size: 4em; position: relative; left: 50%;" />
    ) : (
      <div class={[classes.container, 'micro-app-fixes'].join(' ')}>
        <div class={classes.header}>
          <h1 class={classes.title}>{title}</h1>
          {subtitle && <h2 class={classes.subtitle}>{subtitle}</h2>}
        </div>
        <div
          class={classes.body}
          onmouseleave={handleContainerLeave.bind(props)}
        >
          <upd-carousel
            trackWidth={trackWidth}
            scrollable={scrollable}
            slideWidth={slideWidth}
            slideCount={cards.length}
            onchange={handleCarouselChange.bind(props)}
          >
            {cards.map((card, index) => (
              <div key={index} class={classes['card-container']} slot="item">
                {
                  <Card
                    {...{
                      ...card,
                      index,
                      handleEnterCard: handleEnterCard.bind(props),
                      handleLeaveCard: handleLeaveCard.bind(props),
                      handleCardClick: handleCardClick.bind(props),
                    }}
                  />
                }
              </div>
            ))}
          </upd-carousel>
        </div>
        <div class={classes.dots}>
          {cards.map((card, index) => (
            <div
              key={index}
              class={[
                classes.dot,
                card.mode === 'MOBILE' ? classes.active : '',
              ].join(' ')}
            />
          ))}
        </div>
        <div class={classes.footer}>
          <button
            class={classes['dashboard-link']}
            onclick={handleDashboardClick.bind(props)}
          >
            {dashboardLink.label}
          </button>
        </div>
      </div>
    ),
    element
  );
};
